var map = {
	"./all.png": 2990,
	"./janek.png": 3632,
	"./karol.png": 2792,
	"./karol_old.png": 2646,
	"./mateusz.png": 7967,
	"./mateusz_old.png": 1674,
	"./milosz.png": 1713
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7604;